import type { FC } from 'react';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import Circle from '@mui/icons-material/Circle';

export interface DiffIndicator {
  comparisonDiff: number;
  centerValue?: boolean; // if zero diff or no data, centre the value - no invisible placeholder icon
}

const DiffIndicator: FC<DiffIndicator> = ({
  comparisonDiff,
  centerValue = false,
}) => (
  <>
    {/* Used as a placeholder when not showing up arrow or down arrow. */}
    {comparisonDiff === 0 && !centerValue && <Circle style={{ opacity: 0 }} />}

    {comparisonDiff > 0 && (
      <ArrowDropUp data-test-id="number-difference-arrow-up" />
    )}

    {comparisonDiff < 0 && (
      <ArrowDropDown data-test-id="number-difference-arrow-down" />
    )}
  </>
);

export default DiffIndicator;
